import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/gse-sst-deployment/gse-sst-deployment/packages/frontend/src/app/book/BookLayoutClient.tsx");
